import React from 'react';
import { Box, Tooltip } from '@chakra-ui/react';
import PropTypes from 'prop-types';

import { Statuses } from '../../constants/statuses';
import { getStatusDisplayName } from '../../utils/statusUtil';
import StatusCircle from '../StatusCircle';

const JobStatusIcon = ({ status }) => {
  const variantMap = {
    not_approved: 'error',
    approved: 'success',
    archived: 'archived'
  };

  return (
    <Box minH="16px" minW="16px">
      <Tooltip
        hasArrow
        label={getStatusDisplayName(status)}
        placement="top"
        variant={variantMap[status]}
      >
        <svg height="16px" viewBox="-8 0 16 16" width="16px">
          <g>
            <StatusCircle status={status} />
          </g>
        </svg>
      </Tooltip>
    </Box>
  );
};

JobStatusIcon.propTypes = { status: PropTypes.oneOf([Statuses.NotApproved, Statuses.Approved, Statuses.Archived]) };

export default JobStatusIcon;
